import { Routes, Route } from 'react-router-dom'
import Landing from './Landing'
import SignUp from './SignUp'
import Documentation from './Documentation'

export default function HomeAnonymous() {
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/documentacion" element={<Documentation />} />
            <Route path="*" element={<Landing />} />
        </Routes>
    )
}
